<template>
  <div class="sticky-donate-bar lg:hidden">
    <div
      @click="toggleWidget"
      class="w-full px-6 py-2 bg-orange-600 inline-flex justify-center items-center gap-6 cursor-pointer max-h-14 top-bar"
    >
      <div class="flex justify-start items-center gap-4">
        <div
          class="justify-center text-white text-2xl font-bold font-['Roboto_Condensed'] leading-8"
        >
          DONATE TO LIBERTIES
        </div>
        <div
          class="arrow-container w-10 h-10 relative overflow-hidden"
          :class="{ 'is-open': isOpen }"
        >
          <div v-html="icons.arrow" class="w-5 h-3  absolute"></div>
        </div>
      </div>
    </div>
    <div v-show="isOpen" class="widget-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import * as Icons from '../Utils/icons';

export default {
  name: 'StickyDonateBar',
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleWidget() {
      this.isOpen = !this.isOpen;
    }
  },
  computed: {
    icons: () => Icons
  }
};
</script>

<style scoped>
.top-donation-widget .latest-widget-styles {
  margin-top: 0 !important;
}
.top-bar {
  max-height: 56px !important;
}
.sticky-donate-bar {
  background-color: #ec5713;
  position: sticky;
  top: 0;
  z-index: 1000; /* Ensure it stays on top of other content */
}

.arrow-container {
  transition: transform 0.3s ease-in-out;
}

.arrow-container.is-open {
  transform: rotate(180deg); /* Open state: pointing down */
}

.widget-content {
  /* Optional: adds a nice slide-down effect */
  transition: all 0.3s ease-in-out;
}
</style>
